import { useEffect, useState } from 'react'
import orderBy from 'lodash/orderBy'
import { db } from '../../config/firebase'
import mapCampaignLinkListItem from './mapCampaignLinkListItem'

const MAX_LINKS = 300
const SUBSCRIPTION_ERROR_MESSAGE = 'Не вдалося завантажити список посилань'

const useCampaignLinksSubscription = (uid) => {
  const [links, setLinks] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!uid) {
      setLinks([])
      setError('')
      setIsLoading(false)
      return undefined
    }

    setIsLoading(true)

    const query = db.collection('campaign_links')

    const unsubscribe = query.onSnapshot(
      (snapshot) => {
        const nextLinks = orderBy(
          snapshot.docs.map((doc) => {
            const link = mapCampaignLinkListItem(doc.id, doc.data())

            return {
              ...link,
              createdAtSort: link.createdAt?.seconds || 0,
            }
          }),
          ['updatedAtSort'],
          ['desc']
        ).slice(0, MAX_LINKS)

        setLinks(nextLinks)
        setError('')
        setIsLoading(false)
      },
      (snapshotError) => {
        console.error('[useCampaignLinksSubscription] failed:', snapshotError)
        setError(snapshotError?.message || SUBSCRIPTION_ERROR_MESSAGE)
        setIsLoading(false)
      }
    )

    return () => unsubscribe()
  }, [uid])

  return {
    links,
    isLoading,
    error,
  }
}

export default useCampaignLinksSubscription
